import React from "react";
import "./Loader.css"

function SmallLoader ({size, color}){

    const spinnerStyle = {
        width: size,
        height: size,
        borderColor: `rgba(0, 0, 0, 0.1)`,
        borderLeftColor: color
      };

    return (
        <div className="small_spinner_parent">
        <div className="small_spinner" style={spinnerStyle}></div>
      </div>
    )
}

export default SmallLoader;